module.exports = __webpack_public_path__ + "static/img/2.a620d7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/2.png
// module id = hviy
// module chunks = 0